var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _rect, _path255;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarBackParked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 128,
    viewBox: "0 0 122 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1509 60.2076L31.3774 58.7924",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3773 58.7924L33.1226 58.0378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1227 58.038L47.1321 56.3398",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1321 56.3396L61.2358 56.1981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 56.1981L75.3395 56.3396",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3396 56.3398L89.349 58.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.349 58.0378L91.0943 58.7924",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0942 58.7924L92.3206 60.2076",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 71.5283L47.7452 72.0943",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7453 72.0944L34.3019 73.3208",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3019 73.3208L32.7453 73.9811",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7453 73.9812L31.8019 75.3019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8019 75.3019L32.3208 79.7358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3207 79.7358L32.9811 81.1981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9811 81.1981L34.3491 82.0472",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3491 82.0471L39.6321 82.4244",
    stroke: "black",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.632 82.4247L61.2358 82.236",
    stroke: "black",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 82.236L82.8395 82.4247",
    stroke: "black",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8395 82.4244L88.1225 82.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1226 82.0472L89.4905 81.1981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4905 81.1981L90.198 79.7358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.198 79.7358L90.6697 75.3019",
    stroke: "black",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6698 75.3019L89.7264 73.9812",
    stroke: "black",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7263 73.9811L88.2169 73.3208",
    stroke: "black",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2169 73.3208L74.7263 72.0944",
    stroke: "black",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7263 72.0943L61.2358 71.5283",
    stroke: "black",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6415 74.1698L29.6792 72.9434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6792 72.9433L31.0943 72.1887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0943 72.1889L35.8113 71.1511",
    stroke: "black",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8113 71.151L48.4999 70.0189",
    stroke: "black",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 70.0189L61.2358 69.4529",
    stroke: "black",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 69.4529L73.9716 70.0189",
    stroke: "black",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9716 70.0189L86.6603 71.151",
    stroke: "black",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6603 71.1511L91.4244 72.1889",
    stroke: "black",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4244 72.1887L92.7923 72.9433",
    stroke: "black",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7924 72.9434L93.8301 74.1698",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2359 68.5094L48.3113 68.7453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3113 68.7455L35.434 69.8304",
    stroke: "black",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.434 69.8303L32.7453 69.4529",
    stroke: "black",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7452 69.4527L30.5754 67.8489",
    stroke: "black",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5754 67.8492L30.0566 58.1323",
    stroke: "black",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0566 58.132L30.8585 56.6225",
    stroke: "black",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8585 56.6228L32.4151 55.7738",
    stroke: "black",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M32.415 55.7735L46.7546 53.6508",
    stroke: "black",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7546 53.6509L61.2358 53.3209",
    stroke: "black",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 53.3209L75.7169 53.6509",
    stroke: "black",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7169 53.6508L90.0565 55.7735",
    stroke: "black",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0565 55.7738L91.6131 56.6228",
    stroke: "black",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6131 56.6225L92.4622 58.132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4622 58.1323L91.9434 67.8492",
    stroke: "black",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9433 67.8489L89.7735 69.4527",
    stroke: "black",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7735 69.4529L87.0848 69.8303",
    stroke: "black",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0848 69.8304L74.1603 68.7455",
    stroke: "black",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1603 68.7453L61.2358 68.5094",
    stroke: "black",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M114.585 109.453L107.038 108.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M107.038 108.038H61.2358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 108.038H15.4811",
    stroke: "black",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4812 108.038L7.88684 109.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76416 94.1228H61.2358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 94.1228H116.755",
    stroke: "black",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 94.1225L15.6226 89.6414",
    stroke: "black",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6227 89.6415L16.5189 88.9812",
    stroke: "black",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5189 88.9811L20.434 88.3679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.434 88.3679H61.2358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 88.3679H102.085",
    stroke: "black",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M102.085 88.3679L106 88.9811",
    stroke: "black",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M106 88.9812L106.849 89.6415",
    stroke: "black",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M106.849 89.6414L109.113 94.1225",
    stroke: "black",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9528 108.038V101.292",
    stroke: "black",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9528 101.293L41.1414 100.538",
    stroke: "black",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1415 100.538L42.7453 99.3113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7452 99.3113H61.2358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 99.3113H79.7263",
    stroke: "black",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7263 99.3113L81.3301 100.538",
    stroke: "black",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3301 100.538L81.5188 101.293",
    stroke: "black",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5188 101.292V108.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 117.283H87.3678",
    stroke: "black",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3678 117.283L87.2735 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2735 118.038L87.6509 119.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6509 119.453L88.7358 120.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7358 120.774L90.2924 121.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2924 121.575L92.2735 121.906",
    stroke: "black",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2735 121.906L94.2075 121.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2075 121.575L95.8112 120.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8112 120.774L96.8961 119.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8961 119.453L97.2735 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2735 118.038H99.7735",
    stroke: "black",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7734 118.038V125.491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7734 125.491L100.292 126.811",
    stroke: "black",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M100.292 126.811L100.858 127",
    stroke: "black",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M100.858 127H115.528",
    stroke: "black",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M115.528 127L115.906 126.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M115.906 126.434L116.472 125.491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M116.472 125.491V98.1321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M116.472 98.1323L116.802 93.5568",
    stroke: "black",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M116.802 93.5567L117.321 87.0943",
    stroke: "black",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.321 87.0943L117.179 85.6321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M117.179 85.6319L116.472 84.3112",
    stroke: "black",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M116.472 84.3114L113.453 81.7172",
    stroke: "black",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M113.453 81.717L111.849 80.3491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M111.849 80.3489L110.858 78.5093",
    stroke: "black",
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M110.858 78.5095L112.368 75.3962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M112.368 75.3962L116.189 75.9623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M116.189 75.9621L119.915 74.9716",
    stroke: "black",
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M119.915 74.9718L121.472 73.2736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M121.472 73.2736V70.9623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M121.472 70.9624L119.868 69.3115",
    stroke: "black",
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M119.868 69.3114L115.575 68.0378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M115.575 68.0378L111.047 68.1321",
    stroke: "black",
    strokeWidth: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M111.047 68.1323L109.302 69.6888",
    stroke: "black",
    strokeWidth: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M109.302 69.6887L109.113 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M109.113 72.0471L109.207 74.3113",
    stroke: "black",
    strokeWidth: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M109.207 74.3112L108.5 76.4339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 76.4339L107.321 75.5377",
    stroke: "black",
    strokeWidth: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M107.321 75.5378L103.075 64.4056",
    stroke: "black",
    strokeWidth: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M103.075 64.4055L97.8867 53.7452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8867 53.7454L95.7641 51.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M95.764 51.434L92.981 50.0662",
    stroke: "black",
    strokeWidth: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M92.981 50.0661L77.2263 47.6132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2263 47.6132L61.2358 47",
    stroke: "black",
    strokeWidth: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2358 47L45.2924 47.6132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2925 47.6132L29.4906 50.0661",
    stroke: "black",
    strokeWidth: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4905 50.0662L26.7075 51.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 51.434L24.5849 53.7454",
    stroke: "black",
    strokeWidth: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5849 53.7452L19.3962 64.4055",
    stroke: "black",
    strokeWidth: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3962 64.4056L15.1509 75.5378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1509 75.5377L13.9717 76.4339",
    stroke: "black",
    strokeWidth: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9717 76.4339L13.2642 74.3112",
    stroke: "black",
    strokeWidth: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2642 74.3113L13.3585 72.0471",
    stroke: "black",
    strokeWidth: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3585 72.0471L13.1698 69.6887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1698 69.6888L11.4246 68.1323",
    stroke: "black",
    strokeWidth: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4245 68.1321L6.94342 68.0378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94344 68.0378L2.60382 69.3114",
    stroke: "black",
    strokeWidth: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60377 69.3115L1 70.9624",
    stroke: "black",
    strokeWidth: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1 70.9623V73.2736",
    stroke: "black",
    strokeWidth: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1 73.2736L2.5566 74.9718",
    stroke: "black",
    strokeWidth: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55664 74.9716L6.28305 75.9621",
    stroke: "black",
    strokeWidth: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28308 75.9623L10.151 75.3962",
    stroke: "black",
    strokeWidth: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1509 75.3962L11.6604 78.5095",
    stroke: "black",
    strokeWidth: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6604 78.5093L10.6227 80.3489",
    stroke: "black",
    strokeWidth: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6226 80.3491L9.01886 81.717",
    stroke: "black",
    strokeWidth: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01892 81.7172L6.00006 84.3114",
    stroke: "black",
    strokeWidth: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 84.3112L5.3396 85.6319",
    stroke: "black",
    strokeWidth: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33963 85.6321L5.19812 87.0943",
    stroke: "black",
    strokeWidth: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19812 87.0943L5.71699 93.5567",
    stroke: "black",
    strokeWidth: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71698 93.5568L6 98.1323",
    stroke: "black",
    strokeWidth: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00006 98.1321V125.491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00006 125.491L6.5661 126.434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56604 126.434L6.9434 127",
    stroke: "black",
    strokeWidth: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94342 127H21.6132",
    stroke: "black",
    strokeWidth: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6132 127L22.1793 126.811",
    stroke: "black",
    strokeWidth: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1793 126.811L22.7453 125.491",
    stroke: "black",
    strokeWidth: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7452 125.491V118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7452 118.038H25.2452",
    stroke: "black",
    strokeWidth: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2452 118.038L25.5754 119.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5754 119.453L26.7075 120.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 120.774L28.2641 121.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2642 121.575L30.1981 121.906",
    stroke: "black",
    strokeWidth: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1981 121.906L32.1792 121.575",
    stroke: "black",
    strokeWidth: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1792 121.575L33.7358 120.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7358 120.774L34.8207 119.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8207 119.453L35.198 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1981 118.038L35.1038 117.283",
    stroke: "black",
    strokeWidth: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1038 117.283H61.2358",
    stroke: "black",
    strokeWidth: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7642 59.7831C25.8988 57.4854 25.6921 55.1805 25.1509 52.9434",
    stroke: "black",
    strokeWidth: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M24.349 69.6415C25.1113 66.4037 25.5848 63.1046 25.7641 59.7831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4811 74.5945C16.4626 75.0713 17.5133 75.3898 18.5943 75.5379",
    stroke: "black",
    strokeWidth: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5944 75.5379C19.2905 75.6276 19.9981 75.5307 20.6445 75.2572C21.291 74.9837 21.8532 74.5433 22.2736 73.9812",
    stroke: "black",
    strokeWidth: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6604 78.5097L13.9717 76.4342",
    stroke: "black",
    strokeWidth: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2736 73.981C23.2572 72.693 23.9638 71.2156 24.3491 69.6414",
    stroke: "black",
    strokeWidth: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7641 59.7831L22.0377 67.4718",
    stroke: "black",
    strokeWidth: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0377 67.4718L19.1604 75.5849",
    stroke: "black",
    strokeWidth: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8113 57.8489L21.8019 66.5282",
    stroke: "black",
    strokeWidth: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8019 66.5283L18.6415 75.5378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M25.717 94.1226L24.8679 88.3679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4245 118.038L26.6604 118.887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6603 118.887L27.4151 119.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4151 119.83L28.6415 120.443",
    stroke: "black",
    strokeWidth: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6415 120.443L30.1981 120.726",
    stroke: "black",
    strokeWidth: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1981 120.726L31.8018 120.443",
    stroke: "black",
    strokeWidth: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8019 120.443L32.9812 119.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9811 119.83L33.783 118.887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M33.783 118.887L34.0188 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0188 118.038L33.783 117.189",
    stroke: "black",
    strokeWidth: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M33.783 117.188L32.9811 116.245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9812 116.245L31.8019 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8018 115.585L30.1981 115.349",
    stroke: "black",
    strokeWidth: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1981 115.349L28.6415 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6415 115.585L27.4151 116.245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4151 116.245L26.6603 117.188",
    stroke: "black",
    strokeWidth: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6604 117.189L26.4245 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1037 117.283L34.8207 116.623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8207 116.623L33.7358 115.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7358 115.302L32.1792 114.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1792 114.453L30.1981 114.17",
    stroke: "black",
    strokeWidth: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1981 114.17L28.2642 114.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2641 114.453L26.7075 115.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7075 115.302L25.5754 116.623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5754 116.623L25.2452 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00006 98.1321L6.0944 99.9245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09436 99.9246L7.03776 106.481",
    stroke: "black",
    strokeWidth: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03778 106.481L9.63211 114.217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63208 114.217L10.5755 115.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5755 115.774L11.8962 117",
    stroke: "black",
    strokeWidth: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8962 117L14.5849 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5849 118.038H22.7453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7641 59.7831L28.4528 73.2263",
    stroke: "black",
    strokeWidth: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4528 73.2263L31.3773 85.4905",
    stroke: "black",
    strokeWidth: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3773 85.4904L32.5094 94.1226",
    stroke: "black",
    strokeWidth: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M110.858 78.5097L108.5 76.4342",
    stroke: "black",
    strokeWidth: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M103.877 75.5379C104.958 75.3898 106.009 75.0713 106.99 74.5945",
    stroke: "black",
    strokeWidth: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M100.198 73.9812C100.618 74.5433 101.181 74.9837 101.827 75.2572C102.474 75.5307 103.181 75.6276 103.877 75.5379",
    stroke: "black",
    strokeWidth: 0.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3206 52.9434C96.7794 55.1805 96.5728 57.4854 96.7074 59.7831",
    stroke: "black",
    strokeWidth: 0.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7075 59.7831C96.8867 63.1046 97.3603 66.4037 98.1225 69.6415",
    stroke: "black",
    strokeWidth: 0.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1226 69.6414C98.5078 71.2156 99.2145 72.693 100.198 73.981",
    stroke: "black",
    strokeWidth: 0.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7075 59.7831L100.481 67.4718",
    stroke: "black",
    strokeWidth: 0.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M100.481 67.4718L103.311 75.5849",
    stroke: "black",
    strokeWidth: 0.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6603 57.8489L100.67 66.5282",
    stroke: "black",
    strokeWidth: 0.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M100.67 66.5283L103.83 75.5378",
    stroke: "black",
    strokeWidth: 0.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M116.472 98.1321L116.377 99.9245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M116.377 99.9246L115.434 106.481",
    stroke: "black",
    strokeWidth: 0.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M115.434 106.481L112.84 114.217",
    stroke: "black",
    strokeWidth: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M112.84 114.217L111.896 115.774",
    stroke: "black",
    strokeWidth: 0.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M111.896 115.774L110.623 117",
    stroke: "black",
    strokeWidth: 0.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M110.623 117L107.934 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M107.934 118.038H99.7734",
    stroke: "black",
    strokeWidth: 0.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7546 94.1226L97.6037 88.3679",
    stroke: "black",
    strokeWidth: 0.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0471 118.038L95.8584 118.887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8584 118.887L95.0565 119.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0565 119.83L93.8773 120.443",
    stroke: "black",
    strokeWidth: 0.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8773 120.443L92.2735 120.726",
    stroke: "black",
    strokeWidth: 0.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2735 120.726L90.6697 120.443",
    stroke: "black",
    strokeWidth: 0.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6697 120.443L89.4905 119.83",
    stroke: "black",
    strokeWidth: 0.5
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4905 119.83L88.6886 118.887",
    stroke: "black",
    strokeWidth: 0.5
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6885 118.887L88.4999 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4999 118.038L88.6885 117.189",
    stroke: "black",
    strokeWidth: 0.5
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6886 117.188L89.4905 116.245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4905 116.245L90.6697 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6697 115.585L92.2735 115.349",
    stroke: "black",
    strokeWidth: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2735 115.349L93.8773 115.585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8773 115.585L95.0565 116.245",
    stroke: "black",
    strokeWidth: 0.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0565 116.245L95.8584 117.188",
    stroke: "black",
    strokeWidth: 0.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8584 117.189L96.0471 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3679 117.283L87.6509 116.623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6509 116.623L88.7358 115.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7358 115.302L90.2924 114.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2924 114.453L92.2735 114.17",
    stroke: "black",
    strokeWidth: 0.5
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2735 114.17L94.2075 114.453",
    stroke: "black",
    strokeWidth: 0.5
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2075 114.453L95.8112 115.302",
    stroke: "black",
    strokeWidth: 0.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8112 115.302L96.8961 116.623",
    stroke: "black",
    strokeWidth: 0.5
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8961 116.623L97.2735 118.038",
    stroke: "black",
    strokeWidth: 0.5
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7075 59.7831L94.066 73.2263",
    stroke: "black",
    strokeWidth: 0.5
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0659 73.2263L91.0942 85.4905",
    stroke: "black",
    strokeWidth: 0.5
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0942 85.4904L89.9622 94.1226",
    stroke: "black",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    width: 25,
    height: 28,
    rx: 2,
    fill: "#254292"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9375 21V6.45455H63.2159C64.2955 6.45455 65.2401 6.66761 66.0497 7.09375C66.8594 7.51989 67.4891 8.11884 67.9389 8.89062C68.3887 9.66241 68.6136 10.5644 68.6136 11.5966C68.6136 12.6383 68.3816 13.5402 67.9176 14.3026C67.4583 15.0649 66.812 15.652 65.9787 16.0639C65.1501 16.4759 64.1818 16.6818 63.0739 16.6818H59.3239V13.6136H62.2784C62.7424 13.6136 63.1378 13.5331 63.4645 13.3722C63.7959 13.2064 64.0492 12.9721 64.2244 12.669C64.4044 12.366 64.4943 12.0085 64.4943 11.5966C64.4943 11.1799 64.4044 10.8248 64.2244 10.5312C64.0492 10.233 63.7959 10.0057 63.4645 9.84943C63.1378 9.68845 62.7424 9.60795 62.2784 9.60795H60.8864V21H56.9375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarBackParked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carBackParked.3a5f83838f5089402d9e2e9a5deb2629.svg";